//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'an-toggle',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    offTitle: {
      type: String,
      default: null
    },
    onTitle: {
      type: String,
      default: null
    }
  },
  computed: {
    toggleStatus() {
      return this.value ? 'toggleOn' : 'toggleOff';
    }
  },
  methods: {
    onClick() {
      this.$emit('input', !this.value);
      this.$emit('change', !this.value);
    }
  }
};
